import Vue from 'vue';
import Vuex from 'vuex';
import api from '~/core/api'; // @note Чето не подтягивает глобальный api из vue.config.js

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        auth: {
            token: localStorage.getItem('authToken') || '',
            code:  localStorage.getItem('authCode')  || '',
        }
    },

    // Мутации используются для синхронных транзакций и должны содержать только синхронные операции.
    // Usage as: store.commit('setAuthToken', '<hash>');
    mutations: {
        /**
         * Example usage in Vue components: this.$store.commit('setAuthToken', token);
         * @param {Object} state
         * @param {String} token
         */
        setAuthToken(state, token) {
            localStorage.setItem('authToken', token);
            state.auth.token = token;
        },
        setAuthCode(state, code) {
            localStorage.setItem('authCode', code);
            state.auth.code = code;
        }
    },

    // Действия используются для выполнения асинхронных операций, с последующим вызовом мутаций.
    // Usage as: this.$store.dispatch('setAuthToken', token);
    actions: {
        /**
         * Example usage in Vue components: store.dispatch('setAuthToken', token);
         * @param {Store} context Signature: context.state, context.commit, etc..
         * @param {String} code
         */
        authByCode(context, code) {
            // @todo Try fetch code from state.auth.code if empty

            context.commit('setAuthCode', code);

            let params = {code: code};
            api.post(`auth-by-code`, params).then(response => {
                if (response.data.success && response.data.token) {
                    context.commit('setAuthToken', response.data.token);

                    console.log('setAuthToken: reload');
                    Vue.notify({type: 'success', text: `Успішно авторизовано.`});
                    //this.$notify({type: 'success', text: `...`});

                    //location.reload(); // Костыль чтобы обновилось меню
                    //Vue.router.push('/');
                } else {
                    context.commit('setAuthToken', '');
                    //this.$notify({type: 'error', duration: 10000, text: `...`});
                    Vue.notify({type: 'error', duration: 10000, text: `Помилка авторизації!`});
                }
            }).catch(err => { // config request response
                const msg = (err.response.data && err.response.data.message) ? err.response.data.message : `${err.response.status} ${err.response.statusText}`;
                console.log('Auth error:', err.response, msg);
                Vue.notify({type: 'error', duration: 10000, text: `Помилка авторизації: ${msg}`});
            });
        },
    }
});

export default store;
